import axios from "@/api/axiosInstance";

export const deactivateUser = async (
  employeeUuid: string,
): Promise<void> => {
  await axios.delete(`/api/private/admin/employees/${employeeUuid}/identity`);
};